import { Flex, Text, Button } from "@chakra-ui/react";
import { CollapsibleNavBar } from "../../components/navbar/CollapsibleNavBar";
import { useScrollVisibility } from "../../hooks/useScrollVisibility";
import { useIsSmallBreakpoint } from "../../utils/useBreakpoints";
import { useTopBarHeight } from "../../hooks/userTopBarHeight";

export function PromoRibbion({ 
  focusPayment,
  bgColor = "yellow.500",
  textColor = "black",
  text = "Special promo! Unlock Apollyon + over 100,000 titles for one full year",
  ctaText = "Subscribe now"
}: { 
  focusPayment: () => void;
  bgColor?: string;
  textColor?: string;
  text?: string | JSX.Element;
  ctaText?: string;
}) {
  const { isHidden } = useScrollVisibility();
  const isSmallBreakpoint = useIsSmallBreakpoint();
  const topBarHeight = useTopBarHeight();

  return (
    <CollapsibleNavBar
      isCollapsed={isHidden}
      shouldCollapse={isSmallBreakpoint}
      boxProps={{
        position: "sticky",
        top: `${topBarHeight.get()}px`,
        zIndex: 1,
        bg: "charcoal.charcoal",
        width: "100%",
      }}
    >
      <Flex
        padding="12px 24px"
        backgroundColor={bgColor}
        width="100%"
        gap="20px"
        justifyContent="center"
        alignItems="center"
        color={textColor}
      >
        <Text
          fontFamily="Bricolage Grotesque 24pt"
          fontSize="16px"
          fontWeight="600"
          lineHeight="130%"
          textAlign="center"
        >
          {text}
        </Text>
        <Button
          variant="tertiary"
          onClick={focusPayment}
          color={textColor}
          borderColor="transparent.charcoal.50"
          p="6px 16px"
          borderRadius="10px"
          boxShadow="0 8px 12px 0 rgba(0, 0, 0, 0.20)"
          minWidth="none"
        >
          {ctaText}
        </Button>
      </Flex>
    </CollapsibleNavBar>
  );
}
